<div class="dropdown" #dropdownContainer [class.disabled]="disabled" style="width: 100%;">
  <button class="form-select input-label"
          type="button"
          [ngClass]="{'is-invalid': isInvalid}"
          [disabled]="disabled"
          (click)="toggleDropdown()"
          [attr.aria-expanded]="isOpen">
    <div>{{ displayText }}</div>

    <span class="caret float-end"></span>
  </button>
  <div *ngIf="isInvalid" class="invalid-feedback">{{invalidFeedback}}</div>

  <ul class="dropdown-menu " [class.show]="isOpen" #dropdownMenu>

    <li class="px-1 py-1">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Filter..." [(ngModel)]="filterText" (input)="filterItems()"
               (click)="$event.stopPropagation()">
        <button class="btn btn-secondary" type="button" id="button-addon2" (click)="clearFilter()"><i class="bi bi-x"></i></button>
      </div>
    </li>
    <li>
      <hr class="dropdown-divider">
    </li>

    @for (item of filteredItems; track item.key) {
    <li>
      <a class="dropdown-item" href="#" [class.disabled]="item.disabled" [class.active]="isSelected(item)"
         (click)="selectItem(item, $event)">
        {{ item.value }}
      </a>
    </li>
    }
    @if (filteredItems.length === 0) {
    <li class="dropdown-item text-muted">No items found</li>
    }
  </ul>
</div>
